import ApiService from "@/common/api/api.service";

let endpoint = "Proposta";

const RecursoHumano = {

    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvar(form) {
        if(form.alocacaoHoraIndividualId){
            return ApiService.put(`${endpoint}/recurso-humano`, form);
        }else{
            return ApiService.post(`${endpoint}/recurso-humano`, form);
        }
    },

    deletar(form) {
        return ApiService.delete(`${endpoint}/recurso-humano`, form);
    },

    buscar(id){
        return ApiService.get(`${endpoint}/recurso-humano?propostaId=${id}`);
    }
}

export default RecursoHumano;